import { render, staticRenderFns } from "./PlayerContests.vue?vue&type=template&id=1cd5d05e&"
import script from "./PlayerContests.vue?vue&type=script&lang=js&"
export * from "./PlayerContests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports